import {useCallback, useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {useHistory, useLocation} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {Button, makeStyles} from '@material-ui/core';
import NavBar from './navbar';
import TopBar from './topbar';
import {getUserPreferences, updateUserPreference} from '../../../store/actions';
import UtilService from '../../../helper/service';
import clsx from "clsx";
import {Link} from "react-router-dom";
import roles from "../../../helper/roles";
import Config from "../../../config/config";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 65,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 65
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: 0
    },
  },
  topbar: {
    backgroundColor: '#fff',
  },
  displayTopBar: {
    paddingTop: 0,
  },
  putCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  displayTrialTopbar :{
    paddingTop: '123px !important',
    // '@media (max-width: 1338px)': {
    //   paddingTop: '160px !important',
    // },
    // '@media (max-width: 920px)': {
    //   paddingTop: '202px !important',
    // },
    // '@media screen and (max-width: 599px)': {
    //   paddingTop: '155px !important',
    // },
  },
  addNewBtn: {
    fontFamily: 'roboto-regular',
    marginLeft: 5,
    marginRight: 5,
    letterSpacing: '-0.21px',
    width: '278px'
  },
  btn: {
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    marginTop: 20
  },
  dftbtn:{
    height: 37,
    borderRadius: 6,
    background: '#f2f2f2',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    marginTop: 20
  },
  link: {
    color: '#0179EE',
    textDecoration: 'none',
    fontWeight: 600,
    marginTop: 20
  },
}));

function DashboardLayout({ children }: any) {
  const classes = useStyles();
  const history = useHistory();

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const { userMetrics } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { addParticipantList } = userMetrics;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { userPreferencesData, timezone} = useSelector((state: any) => state.authUser);
  const { billingDetails, trailheader} = useSelector((state: any) => state.adminUser);
  const [displayTrialTopbar, setdisplayTrialTopbar] = useState(false);
  const [isTrial, setIsTrial] = useState(false);
  const [isBillingPage, setIsBillingPage] = useState(false);
  const [disableExplore, setDisableExplore] = useState(true);
  const [trialperiod, settrialperiod] = useState(0);
  const real_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(()=>{
    if(billingDetails && billingDetails.data){
      const billingdetail = billingDetails.data;
      const temp_trial_period = UtilService.calculateTrialDays(billingdetail.pay_started_at);
      let trial_period = billingdetail.billing_period  - temp_trial_period;
  
      if(trial_period < 0){
        trial_period = 0
      }
      settrialperiod(trial_period);
    
      if(billingdetail.pay_status == 'TRIAL'){
        setIsTrial(true);
      }
    }
  }, [billingDetails]);

  useEffect(() => {
    if(location.pathname.includes('/creator/dashboard') || 
        location.pathname.includes('/overview') ||
        location.pathname.includes('/participants') ||
        location.pathname.includes('/analyze') || 
        location.pathname.includes('/compare') || 
        location.pathname.includes('/user/profile')){
        setdisplayTrialTopbar(trailheader) 
    }
  }, [trailheader]);

  const displayTopBar = useMemo(() => {
    if (
      (location.pathname.includes('/creator/experience-builder') && !addParticipantList)
      || location.pathname.includes('/creator/onboarding')
      || location.pathname.includes('/participant/planning')
      || (location.pathname.includes('/creator/experience-manager/invite') && !addParticipantList)
      || location.pathname.includes('/creator/experience-manager/manage-hubs')
    ) {
      return false
    } else {
      return true
    }
  }, [location, addParticipantList]);

  useEffect(() => {
    if (userPreferencesData.length > 0) {
      UtilService.storeData = timezone;
    } else {
      const request = {
        user_id: loginUserData.user_id
      };
      dispatch(getUserPreferences(apolloClient.client, request));
    }
  }, [userPreferencesData]);

  useEffect(() => {
    const local_timezone = localStorage.getItem('real_timezone');
    if (!local_timezone) {
      localStorage.setItem("real_timezone", real_timezone)
    } else {
      if (real_timezone !== local_timezone) {
        onUpdateTimezone();
        localStorage.setItem("real_timezone", real_timezone);
      }
    }
  }, []);
  
  useEffect(() => {
    if (loginUserData && loginUserData.role_access) {
      if (loginUserData.role_access.length) {
        const admin_user = loginUserData.role_access.filter((val: any) => val.access_name === "admin_users");
        const trial_admin = loginUserData.role_access.filter((val: any) => val.access_name === "trial_admin");
        if ((admin_user.length > 0 && admin_user[0].access_value) || (trial_admin.length > 0 && trial_admin[0].access_value)) {
          if (location.pathname.includes('/admin/billing') || location.pathname.includes('/admin/user')) {
            setIsBillingPage(true);
          }
          setDisableExplore(false);
        }
      }
    }
  }, [loginUserData]);

  const onUpdateTimezone = () => {
    const pf_id = (userPreferencesData.filter((data: any) => data.preference_name === "TIMEZONE"))[0]?.preference_id
    const request = {
      user_id: loginUserData.user_id,
      preference_id: pf_id,
      preference_value: true,
      preference_information: real_timezone,
    };
    dispatch(updateUserPreference(apolloClient.client, request));
  }

  const redirectToContactUs = () => {
    window.open(Config.CONTACT_US_URL, '__blank');
  }

  const redirectToBilling = () => {
    let url = `/admin/billing`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['admin'])) {
      url = `/subscriber/admin/billing`;
    }
    // if(location.pathname.includes('/admin/billing')){
      history.push(url)
    // }
  }

  const displayNavBar = useCallback(() => {
    return true;
  }, [location]);
  return (
    <div className={classes.root}>
      {billingDetails && billingDetails.data && isTrial && trialperiod == 0 && !isBillingPage &&
        <div className={"restrict-page-wrapper"}>
          <div className={"empty"}>
            <div className={"restrict-content-wrapp"}>
              <img className={'restrict-lock-Image'} src={'/assets/icons/lock-icon.svg'} alt={'img'} />
              <img className={'restrict-Image'} src={'/assets/icons/restrict-page.svg'} alt={'img'} />
              <div className={'title'}>
                {(billingDetails.data.is_subscription_expired)?
                  "Your plan is expired"
                  :
                  "Your trial is over, but this is where the real story begins"
                }
              </div>
              
              <div className={'subtitle'}>
                To keep access to your measurements and continue using Immersion, subscribe or contact us to chat about our affordable plans.
              </div>
              <Button
                className={disableExplore ? classes.dftbtn : classes.btn}
                onClick={redirectToBilling}
                disabled={disableExplore}
              >
                <span className={classes.addNewBtn}>EXPLORE PLANS</span>
              </Button>
              <div className={'subtitle'}>
                OR
              </div>
              <div className={'subtitle'}>
                <Link to={"#"} onClick={redirectToContactUs} className={classes.link}  target='_blank'>Get in touch with our team</Link>
              </div>
            </div>
          </div>
        </div>
      }
      {billingDetails && billingDetails.data && billingDetails.data.pay_status == 'payment_failed' && !isBillingPage &&
        <div className={"restrict-page-wrapper"}>
          <div className={"empty"}>
            <div className={"restrict-content-wrapp"}>
              <img className={'restrict-lock-Image'} src={'/assets/icons/lock-icon.svg'} alt={'img'} />
              <img className={'restrict-Image'} src={'/assets/icons/restrict-page.svg'} alt={'img'} />
              <div className={'title'}>
                Payment attempt failed !
              </div>
              
              <div className={'subtitle'}>
                Please enter your credit card detail from billing page.
              </div>
              <Button
                className={disableExplore ? classes.dftbtn : classes.btn}
                onClick={redirectToBilling}
                disabled={disableExplore}
              >
                <span className={classes.addNewBtn}>Go to Billing </span>
              </Button>
              <div className={'subtitle'}>
                OR
              </div>
              <div className={'subtitle'}>
                <Link to={"#"} onClick={redirectToContactUs} className={classes.link}  target='_blank'>Get in touch with our team</Link>
              </div>
            </div>
          </div>
        </div>
      }
      
      
      {displayTopBar && (
        <TopBar
          className={classes.topbar}
          isMobileNavOpen={isMobileNavOpen}
          onMobileNavOpen={() => {
            setMobileNavOpen(!isMobileNavOpen)
          }}
        />
      )}
      {displayNavBar() && (
        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
      )}
      <div
        className={classes.wrapper + ' ' + (!displayTopBar ? classes.displayTopBar : '') + ' ' + (displayTrialTopbar ? classes.displayTrialTopbar : "" ) }
        style={ displayNavBar() ? {} : { paddingLeft: 0 } }
      >
        <div className={classes.contentContainer}>
          <div className={
            (location.pathname.includes('/creator/experience-manager/invite') && !addParticipantList)
              ? clsx(classes.content, classes.putCenter)
              : classes.content
          } >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;